module.exports = __webpack_public_path__ + "static/media/user-circle-solid.c3580913.svg";